import { Alert, Button, Form, Input, Modal, Space, Switch, Table } from 'antd'
import iconEmpty from 'icons/createproject/supportneed.svg'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
//checkrole
import {
  PlusOutlined,
  RedoOutlined,
  SearchOutlined
} from '@ant-design/icons'
import {
  addBusiness,
  getResultBusinessV2,
  updateBusiness
} from 'api/MasterData/business'
import DeleteBusinessunit from 'common/Management/delete'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
import { toUpper } from 'lodash'
import { CounterContext } from 'redux/Golbalvalues'
const BusinessContainer = styled.div``
const EmptyContainer = styled.div``
const Container = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let wordError = ''
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const Business = () => {
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [dataBu, setDataBu] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [hiddenError, setHiddenError] = useState(true)

  //search
  const [searchedColumn, setSearchedColumn] = useState('')
  const [searchText, setSearchText] = useState('')
  const [form] = Form.useForm()

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [switchValue, setSwitchValue] = useState(true)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 17) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // call data business
  const getDataBusiness = async () => {
    await getResultBusinessV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataBu([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataBu(data.result)
          setIsLoading(false)
        } else {
          setDataBu([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataBu([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataBusiness()
    }
  }, [token])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            Search
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) => (searchedColumn === dataIndex ? text : text),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      title: <h5>Business Group Code</h5>,
      dataIndex: 'business_code',
      sorter: (a, b) => a.business_code.localeCompare(b.business_code),
      ellipsis: true,
      ...getColumnSearchProps('business_code'),
    },
    {
      title: <h5>Local Business Group Name</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>English Business Group Name</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      width: 180,
      render: (_, record) => <span>{record.data.status}</span>,
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]

  const dataSource = dataBu.map((item) => ({
    id: item.id,
    business_code: item.code,
    local_name: item.name,
    english_name: item.name_en,
    data: item,
    status: item.status, // เพิ่ม status เป็น property แยกต่างหาก
  }))

  const onFinish = (value) => {
    const onChangeStatus = value.status ? 'Active' : 'Inactive'

    if (stateDrawer === 'add') {
      const data = {
        code: value.bu_code,
        name: value.localName,
        name_en: value.engName,
        status: value.status ? 'Active' : 'Inactive', // เพิ่มส่วนนี้
      }
      try {
        addBusiness({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getDataBusiness()
            setVisible(false)
            setSwitchValue(true) // รีเซ็ตค่า switch เป็น true หลังจากเพิ่มข้อมูลสำเร็จ
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_bu_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: dataEdit.id,
        code: value.bu_code,
        name: value.localName,
        name_en: value.engName,
        status: value.status ? 'Active' : 'Inactive', // เพิ่มส่วนนี้
      }
      try {
        updateBusiness({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getDataBusiness()
            setVisible(false)
            setSwitchValue(true)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_bu_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const eventAdd = () => {
    form.resetFields()
    setSwitchValue(true)
    form.setFieldsValue({
      bu_code: null,
      localName: null,
      engName: null,
      status: true, // ตั้งค่าเริ่มต้นเป็น true (Active)
    })
    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer('Add Business Group')
  }

  const eventEdit = (data) => {
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    const isActive = data.data.status
    setSwitchValue(isActive === 'Active') // ตรวจสอบสถานะเป็น Active หรือไม่

    form.setFieldsValue({
      bu_code: data.business_code,
      localName: data.local_name,
      engName: data.english_name,
      status: switchValue,
    })
    setHiddenError(true)
    setDataEdit(data)
    setStateDrawer('edit')
    setTitleDrawer('Edit Business Group')
    setVisible(true)
  }

  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }

  const onChangeBu_code = (event) => {
    form.setFieldsValue({
      bu_code: event.target.value.replace(/\s/g, ''),
    })
  }

  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
            hidden={permissionPage.delete ? false : true}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form.submit}
            type="primary"
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }

  const onClose = () => {
    setVisible(false)
  }

  const content = () => {
    if (dataBu.length > 0) {
      return (
        <Container>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <Button
                id="add"
                onClick={eventAdd}
                icon={<PlusOutlined className="Icon-color" />}
                className="BTN_Next"
                hidden={permissionPage.create ? false : true}
              >
                Add Business Group
              </Button>
              <Button
                id="reset"
                type="primary"
                style={{ marginLeft: 8 }}
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </Header>
          <Body>
            <Table
              key="business_table"
              onRow={(record) => {
                return {
                  onClick: () => eventEdit(record), // click row
                }
              }}
              columns={columns}
              dataSource={dataSource}
              onChange={onChange}
              pagination={pagination}
              showSorterTooltip={false}
            />
          </Body>
        </Container>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>Please add Business Group in your project (optional)</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            id="add"
            onClick={eventAdd}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            Add Business Group
          </Button>
        </EmptyContainer>
      )
    }
  }

  return (
    <BusinessContainer
      style={{ padding: 32 }}
      className="layout-git-master-unitmeasurment"
    >
      {content()}
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement="right"
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        footer={renderButton_Drawer()}
        destroyOnClose
        className="fix-modal"
        centered
      >
        <Form className="disable-page" form={form} layout="vertical" onFinish={onFinish}>
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordError} type="error" showIcon />
            </div>

            <Form.Item
              id="bu_code"
              name="bu_code"
              label={<h4>Business Group Code</h4>}
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter business group code',
                },
              ]}
            >
              <Input
                id="bu_code"
                size="large"
                placeholder="Please enter business group code"
                maxLength={10}
                onChange={onChangeBu_code}
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    bu_code: toUpper(e.target.value),
                  })
                }
              />
            </Form.Item>
            <Form.Item
              id="localName"
              name="localName"
              label={<h4>Local Business Group Name</h4>}
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter local name',
                },
              ]}
            >
              <Input id="localName" size="large" placeholder="Please enter local name" />
            </Form.Item>
            <Form.Item
              id="engName"
              name="engName"
              label={<h4>English Business Group Name</h4>}
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter english name',
                },
              ]}
            >
              <Input id="engName" size="large" placeholder="Please enter english name" />
            </Form.Item>
            <Form.Item
              id="status"
              name="status"
              // label={<h4>Status</h4>}
              valuePropName="checked"
              // initialValue={false}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '8px' }}>Status Active:</span>
                <Switch
                  checked={switchValue}
                  onChange={(checked) => {
                    form.setFieldsValue({ status: checked })
                    setSwitchValue(checked)
                  }}
                />
              </div>
            </Form.Item>
          </fieldset>
        </Form>
        <DeleteBusinessunit
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'business_unit'}
          data={dataEdit}
          renderData={getDataBusiness}
          setVisibleDrawer={setVisible}
        />
      </Modal>
    </BusinessContainer>
  )
}
export default Business
